module.exports = __webpack_public_path__ + "img/xtgl2.8b8085d5.png";